import React from 'react';
// import Logo from '../../img/icon_videoLogger.svg';

// TODO: 왼쪽 상단 LOGO 들어갈 위치
const ProductLogo = () => {
  return (
    <div className="logo">
    {/* <img src='/static/img/icon_videoLogger.svg' alt="logo" /> */}
    </div>
  );
};

export default ProductLogo;


// WEBPACK FOOTER //
// ./src/components/logo/ProductLogo.js